import logo from './logo.svg';
import React,{useState,useEffect} from 'react';
import './App.css';
import './App.scss';
import { MapContainer, TileLayer, useMap,Marker,Popup } from 'react-leaflet'
import TamilNaduMap from './TamilNaduMap';
import Home from '../src/components/Home'
// import { LoginPage } from './LoginPage.jsx';
import { Route, Routes, useNavigate,useLocation } from 'react-router-dom';
import firebase from "./firebase";
import  LoginPage from './LoginPage';
import {checkAcessLevel} from './permission.js'
import Main from './components/Contribution/Main';
import IncentiveDescription from './components/Contribution/Incentive/IncentiveDescription';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation();
  const [accessLevel, setAccessLevel] = useState(false);
  const [accessList, setAccessList] = useState("");
  const [email,setEmail]=useState(null)
  const navigate= useNavigate()
  const [url, setUrl] = useState(location.pathname);
  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  useEffect(() => {
   const unsubscribe = firebase.auth().onAuthStateChanged((authUser) => {
     if (authUser) {
       // setUser(authUser);
       console.log(authUser._delegate.email)
     
       setEmail(authUser._delegate.email)
       
       handleLogin();
       if(window.location.href==='https://samiksha.5cn.co.in/' || window.location.href==='http://localhost:3003/'||
       window.location.href==='https://samiksha.5cn.co.in' || window.location.href==='http://localhost:3003'
       ){

          navigate('/home')
       }

       // //console.log(isSuperAdmin)
     } else {
      
       setIsLoggedIn(false);
       navigate("/login");
     }
   });

   return () => unsubscribe();
 }, [url]);

 const handleLogout = () => {
  firebase
    .auth()
    .signOut()
    .then(() => {
      // User is signed out.
    })
    .catch((error) => {
      console.error("Sign-out error:", error);
    });
  setIsLoggedIn(false);
  navigate("/login");
  window.location.reload()
};

useEffect(() => {
  //console.log('data')
  const handleSuperAdmin = async () => {
    const data = await checkAcessLevel();
    // console.log(data);
  
      data?.user?.filter(data=>{
         if(data?.email===email){
          //console.log(data?.level)
          setAccessLevel(
           data
          
            )
          console.log(data?.access)
         }
      })
    setAccessList(data?.user);
  };

  if (email) {
    handleSuperAdmin();
  }
}, [email]);




  return (
    <div className="App">

       {/* <Home />   */}
       <Routes> 
        <Route exact path="/home" element={
          <Home handleLogout={handleLogout} email={email} accessLevel={accessLevel} accessList={accessList}  />
        } />
        <Route  path="/login" element={
          <LoginPage   />
        } />    

        { accessLevel?.scope==='internal' && <Route  path="/contribution/:tab" element={
          <Main email={email} accessLevel={accessLevel} accessList={accessList}  />
        } /> }

        { accessLevel?.scope==='internal' && <Route  path="/incentivedescription" element={
          <IncentiveDescription />
        } /> 


        
      }  
      </Routes>
     
    </div>
  );
}

export default App;
